<template>
  <svg
    v-bind="svgAttributes"
    :class="className"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",

  props: {
    name: {
      type: String,
      required: true
    },

    title: {
      type: String,
      default: null
    },

    size: {
      type: [Number, String],
      default: 18
    },

    width: {
      type: [Number, String],
      default: null
    },

    height: {
      type: [Number, String],
      default: null
    },

    color: {
      type: String,
      default: "currentColor"
    }
  },

  computed: {
    iconPath() {
      let icon = require(`@/assets/icons/${this.name}.svg`);
      if (Object.prototype.hasOwnProperty.call(icon, "default")) {
        icon = icon.default;
      }

      return icon.url;
    },

    svgAttributes() {
      return {
        width: this.size && !this.width ? this.size : this.width,
        height: this.size && !this.height ? this.size : this.height,
        fill: this.color
      };
    },

    iconName() {
      return this.iconPath.split("#").pop();
    },

    className() {
      return "svg-icon svg-icon--" + this.iconName;
    }
  }
};
</script>

<style>
.svg-icon {
  fill: currentColor;
}
</style>
